<div class="container p-5">
    <form [formGroup]="form">
        <!-- Denial Reason -->
        <div class="form-group row" [class.has-danger]="denialReason?.invalid && denialReason?.touched">
            <label class="col-sm-3 col-form-label required-label">Denial&nbsp;Reason:</label>
            <div class="col-sm-9">
                <select [formControl]="denialReason" class="form-control">
                    <option [ngValue]="null" disabled>Choose a Denial Reason</option>
                    <option *ngFor="let option of ASSISTANCE_APPLICATION_DENIAL_REASON_OPTIONS"
                            [ngValue]="option.value">{{ option.label }}
                    </option>
                </select>
            </div>
        </div>

        <!-- Other Denial Reason -->
        <div class="form-group row"
             *ngIf="denialReason.value?.toString() === 'Other'"
             [class.has-danger]="otherDenialReason?.invalid && otherDenialReason?.touched">
            <label class="col-sm-3 col-form-label required-label">Explanation:</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" [formControl]="otherDenialReason">
            </div>
        </div>

        <!-- Error Message -->
        <div *ngIf="denialReason?.hasError('required') && denialReason?.touched"
             class="alert alert-danger">
            Denial Reason is required.
        </div>

        <button type="submit" class="btn btn-secondary m-2 pull-right" [disabled]="isProcessing" (click)="onClickCancel()">Cancel
        </button>
        <button type="button" class="btn btn-primary m-2 px-1 pull-right" [disabled]="isProcessing" (click)="onClickConfirmDeny()">Confirm
        </button>
    </form>
</div>
